// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"6c61e739","436":"2dd44b9b","682":"8ac783d3","844":"30379b3c"}[chunkId] + ".chunk.js";
};